import { render, staticRenderFns } from "./FlexmessageIndex.vue?vue&type=template&id=18b0ba15&scoped=true&"
import script from "./FlexmessageIndex.vue?vue&type=script&lang=js&"
export * from "./FlexmessageIndex.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageIndex.vue?vue&type=style&index=0&id=18b0ba15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0ba15",
  null
  
)

export default component.exports